import { ReactNode } from 'react';

import { Avatar, Typography } from '@/shared/components/atoms';
import { TypographyVariant } from '@/shared/components/atoms/Typography/Typography.types';

interface CardColumnProps {
  label: string;
  value?: ReactNode;
  icon?: ReactNode;
  labelVariant?: TypographyVariant;
  valueVariant?: TypographyVariant;
}

const CardColumn = ({
  label,
  value,
  icon,
  labelVariant,
  valueVariant,
}: CardColumnProps) => (
  <div className='flex items-center gap-2'>
    {icon ? <Avatar size='lg' icon={icon} /> : ''}
    <div>
      <Typography variant={labelVariant} className='mb-1 text-text-600'>
        {label}
      </Typography>
      <Typography variant={valueVariant} className='text-black' weight='bold'>
        {value || '-'}
      </Typography>
    </div>
  </div>
);

export { CardColumn };
